import styled, { css } from 'styled-components'

import { Colors } from 'common-constants/colors'
import { calculatePosition } from 'components/page/ForeignProfile/Photos/function/calculatePosition'
import { PhotosType } from 'components/page/ForeignProfile/Photos/PhotosTile/PhotosTile.types'
import { draggableThreshold } from 'components/page/PhotoRating/constants'
import { media } from 'components/presentational'
import { RouterLink } from 'components/presentational/link'
import { GQLPhotoFaceCenter } from 'generated-graphql/graphql'

export const WrapperPosition = css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const ImageHugeCss = css`
  display: flex;
  flex-grow: 1;
  position: relative;
  padding-top: calc(100% + calc(100% / 3));
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 10px;

  ${media.tablet`
    border-radius: 10px;
    margin-bottom: 0;
  `}
`

export const ImageHuge = styled(RouterLink)`
  ${ImageHugeCss}
`

export const ImageHugeWithoutLink = styled.div`
  ${ImageHugeCss}
`

export const ImageSquareLarge = styled(RouterLink)`
  display: flex;
  flex-grow: 1;
  position: relative;
  padding-top: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;

  ${media.tablet`    
    display: none;
  `}
`

export const ImageSquare = styled(RouterLink)`
  position: relative;
  width: calc(50% - 10px);
  padding-top: calc(50% - 10px);
  border-radius: 10px;
  overflow: hidden;
`

export const WrapperImagesInline = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;

  ${media.tablet`
    display: none;
  `}
`

export const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const EmptyAvatar = styled.div`
  ${WrapperPosition};
  background-color: ${Colors.specialGray};
`

export type ImageBaseCssProps = {
  $coordinates?: GQLPhotoFaceCenter | null
  width?: number
  height?: number
  $type?: PhotosType
}

const imageBaseCss = css<ImageBaseCssProps>`
  display: block;
  ${WrapperPosition};
  object-fit: cover;
  object-position: ${(props) => calculatePosition(props)};
  border-radius: 10px 0 0 10px;
  overflow: hidden;

  @media (max-width: ${draggableThreshold}px) {
    border-radius: 10px 10px 0 0;
    overflow: hidden;
  }
`

export const Image = styled.img<ImageBaseCssProps>`
  ${imageBaseCss}
`

export const Source = styled.source<ImageBaseCssProps>`
  ${imageBaseCss}
`

export const WrapperLast = styled(RouterLink)`
  display: flex;
  position: relative;
  padding-top: calc(100% - calc(100% / 1.8));
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 20px;
`

export const Mask = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  font-size: 36px;
  letter-spacing: -0.64px;
  background-color: ${Colors.photoMask};
  color: ${Colors.white};
`
